import { put, takeEvery } from "redux-saga/effects"
import { showSavingModal, hideSavingModal } from "../actions"
import { get, post } from "helpers/api_helper"
import {
  getReferFriendFeatureFailed,
  getReferFriendFeatureSuccess,
  getReferFriendReportsFailed,
  getReferFriendReportsSuccess,
  updateReferFriendFeatureFaield,
  updateReferFriendFeatureSuccess,
} from "./actions"
import {
  GET_REFER_FRIEND_FEATURE,
  GET_REFER_FRIEND_REPORTS,
  UPDATE_REFER_FRIEND_FEATURE,
} from "./actionTypes"

function* getReferFriendFeature({ payload: params }) {
  try {
    const response = yield get("/refer-friend/menu-item", { params })
    yield put(getReferFriendFeatureSuccess(response))
  } catch (error) {
    yield put(getReferFriendFeatureFailed(error))
  }
}

function* updateReferFriendFeature({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post("/admin/refer-friend/menu-item", params)
    yield put(updateReferFriendFeatureSuccess(response))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateReferFriendFeatureFaield(error))
  }
}

function* getReferFriendReports({ payload: params }) {
  try {
    const response = yield get("/admin/refer-friend/reports", { params })
    yield put(getReferFriendReportsSuccess(response))
  } catch (error) {
    yield put(getReferFriendReportsFailed(error))
  }
}

function* referFriendSaga() {
  yield takeEvery(GET_REFER_FRIEND_FEATURE, getReferFriendFeature)
  yield takeEvery(UPDATE_REFER_FRIEND_FEATURE, updateReferFriendFeature)
  yield takeEvery(GET_REFER_FRIEND_REPORTS, getReferFriendReports)
}

export default referFriendSaga
